import React, { useState } from 'react';
import Scan from './Scan';
import SmartGateSystem4 from './auto/SmartGateSystem4';

const tabStyle = (active) => ({
    border: 'none',
    borderBottom: active ? '3px solid #0d6efd' : '3px solid transparent',
    background: 'transparent',
    color: active ? '#0d6efd' : '#6c757d',
    fontWeight: active ? 700 : 500,
    padding: '0.75rem 1rem',
    cursor: 'pointer',
});

const OperationsHub = () => {
    const [activeTab, setActiveTab] = useState('detect');

    return (
        <div className="container-fluid py-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <div>
                    <h4 className="mb-1">Parking Operations Hub</h4>
                    <div className="text-muted">
                        Một màn hình để xử lý cả quét RFID và detect tự động sau khi đăng nhập.
                    </div>
                </div>
                <div className="d-flex align-items-center gap-1 border-bottom">
                    <button type="button" style={tabStyle(activeTab === 'rfid')} onClick={() => setActiveTab('rfid')}>
                        RFID Scan
                    </button>
                    <button type="button" style={tabStyle(activeTab === 'detect')} onClick={() => setActiveTab('detect')}>
                        Auto Detect
                    </button>
                </div>
            </div>

            <div className="card shadow-sm border-0">
                <div className="card-body p-0">
                    {activeTab === 'detect' ? <SmartGateSystem4 serverUrl={window.location.origin} /> : <Scan />}
                </div>
            </div>
        </div>
    );
};

export default OperationsHub;
